import React from 'react';
interface DesignNoteProps {
  label: string;
  note: string;
}

/** A design annotation explaining why a section is built the way it is. */
export function DesignNote({
  label,
  note
}: DesignNoteProps) {
  return <p className="mb-6 inline-flex flex-wrap items-center gap-x-3 gap-y-1 border border-dashed border-olive px-4 py-2" data-id="element-35" data-mp="1k97afm4a8hc4">
      <span className="label text-olive" data-id="element-36" data-mp="1ffuppn2q4uon">{label}</span>
      <span className="max-w-xl text-[12.5px] italic leading-relaxed text-muted" data-id="element-37" data-mp="1t8av2uj3l4sq">
        {note}
      </span>
    </p>;
}